<template>
  <div class="home-page-box">
    <!-- 顶部 -->
    <homeHead ref="homeHead" :pages="notice" @homeBtn="searchBtn" :isRouterIndex="'1'"></homeHead>
    <div class="home-page-content">
      <!-- 顶部 -->
      <div class="home-page-content__location">
        <div class="home-page-content__location__item">
          <span>当前位置：</span>
          <span>门户首页</span>
          <span>>></span>
          <span>我的事项</span>
          <span>>></span>
          <span class="active"> {{matterTitle}}</span>
        </div>
      </div>
      <div class="home-page__wrapper">
        <!-- 菜单 -->
        <div class="home-page__menu">
          <img src="./../../../../assets/homeNew/wddb-menu.png" class="menu-img" />
          <div class="menu-box__item " v-for="(item,index) in matterList" :class="matterIndex == index ? 'is-active' : ''" :key="index" @click="matterBtn(item,index)">
            <img :src="item.lan" />
            <span> {{item.name}}</span>
          </div>

        </div>
        <div class="home-page__content">
          <div class="home-page__content__title">
            {{matterTitle}}
          </div>
          <div v-if="authType != 'G' && authType != 'M'">
            <div class="search-header__quick__search">
              <el-input type="text" v-model="inputTitle" placeholder="按标题搜索" @keyup.enter.native="search"></el-input>
              <img src="./../../../../assets/homeNew/search.png" class="home-header__quick__search__icon" />
            </div>
            <div class="home-page__content__subtitle">
              <div v-if="authType == 'A'" class="home-page__content__subtitle__item" @click="handleClick('1')" :class="activeName == '1' ? 'is-active' : ''">待办</div>
              <div v-if="authType == 'A'" class="home-page__content__subtitle__item " @click="handleClick('2')" :class="activeName == '2' ? 'is-active' : ''">待阅</div>
              <div v-if="authType == 'A'" class="home-page__content__subtitle__item" @click="handleClick('3')" :class="activeName == '3' ? 'is-active' : ''">待认领</div>

              <div v-if="authType == 'D'" class="home-page__content__subtitle__item" @click="handleClick('4')" :class="activeName == '4' ? 'is-active' : ''">已办</div>
              <div v-if="authType == 'D'" class="home-page__content__subtitle__item " @click="handleClick('5')" :class="activeName == '5' ? 'is-active' : ''">已阅</div>

              <div v-if="authType == 'C'" class="home-page__content__subtitle__item" @click="handleClick('6')" :class="activeName == '6' ? 'is-active' : ''">已发起</div>
              <div v-if="authType == 'C'" class="home-page__content__subtitle__item" @click="handleClick('7')" :class="activeName == '7' ? 'is-active' : ''">已撤回</div>
            </div>

            <div class="home-page__content__list" v-if="dataList.length > 0">
              <div class="home-page__content__list__item" v-for="(item,index) in dataList" :key="index" @click="goDetail(item)">
                <img :src="item.icon" class="home-page__content__list__item__img" />
                <div class="home-page__content__list__item__content">
                  <div class="home-page__content__list__item__content__title">
                    {{item.title}}
                  </div>
                  <div class="home-page__content__list__item__content__info" v-if="authType != 'C'">
                    <img src="./../../../../assets/homeNew/tjr-icon.png" />
                    提交人: {{ item.userName }}
                  </div>
                  <div class="home-page__content__list__item__content__info" v-if="authType != 'C'">
                    <img src="./../../../../assets/homeNew/dqjd-icon.png" />
                    当前节点:{{ item.nodeName }}
                  </div>
                  <div class="home-page__content__list__item__content__info">
                    <img src="./../../../../assets/homeNew/sqsj-icon.png" />
                    {{ authType == 'C' ? '发起时间': '申请时间'}}:{{ item.sendTime }}
                  </div>
                </div>
              </div>

            </div>
            <div class="no-wrap" v-else>
              <img src="./../../../../assets/homes/nodatas.png" class="no-img" alt="">
              <div class="no-title">
                暂无数据
              </div>
            </div>
            <div class="page-apply">
              <Paging :totalNumber="zongtiaoshu" :pageShowTotal="pageSize" :showActivePageIndex="pageNum" @callBack="handleCurrentChange"></Paging>
            </div>
          </div>

          <div class="workflow-box article-box" v-if="authType == 'G'">
            <div class="article-padding" v-if="noticeList.length > 0 && authType == 'G'">
              <div class="article-list" v-for="(item,index) in noticeList" :key="index" @click="goNotice(item)">
                <div class="icon"></div>
                <div class="title">
                  {{item.title}}
                </div>
                <div class="time">
                  {{item.releaseTime  | analyseTime('1')}}
                </div>
              </div>
              <div class="page-apply">
                <Paging :totalNumber="zongtiaoshu" :pageShowTotal="pageSize" :showActivePageIndex="pageNum" @callBack="handleCurrentChange" :isShowIndex="'1'"></Paging>
              </div>
            </div>

            <div class="no-wrap" v-if="noticeList.length <= 0 && authType == 'G'">
              <img src="./../../../../assets/homes/nodatas.png" class="no-img" alt="">
              <div class="no-title">
                暂无数据
              </div>
            </div>

          </div>

          <div class="workflow-box article-box" v-if="authType == 'M'">

            <div class="article-padding" v-if="noticeList.length > 0 && authType == 'M'">
              <div class="article-list" v-for="(item,index) in noticeList" :key="index" @click="goImIten(item)">
                <div class="icon"></div>
                <div class="title">
                  {{item.title}}
                </div>
                <div class="time">
                  {{item.sendTime  | analyseTime('1')}}
                </div>
              </div>
              <div class="page-apply">
                <Paging :totalNumber="zongtiaoshu" :pageShowTotal="pageSize" :showActivePageIndex="pageNum" @callBack="handleCurrentChange" :isShowIndex="'1'"></Paging>
              </div>
            </div>

            <div class="no-wrap" v-if="noticeList.length <= 0 && authType == 'M'">
              <img src="./../../../../assets/homes/nodatas.png" class="no-img" alt="">
              <div class="no-title">
                暂无数据
              </div>
            </div>

          </div>

        </div>
      </div>
    </div>
    <homeFooter></homeFooter>
    <!-- <div class="back-top-box  tops-btn">
      <img src="./../../../../assets/homes/topsHei.png" class="tops-img" alt="">
      <img src="./../../../../assets/homes/topsWhite.png" class="tops-img-hover" alt="">
      <span class="back-top-box__text">回顶部</span>
    </div> -->

    <el-dialog title="" :show-close="false" :close-on-click-modal="true" :visible.sync="dialogUserPersonVisible" width="800px" append-to-body>
      <div class="message-container">
        <div class="message-container-title">
          {{ messageData.from.title }}
        </div>
        <!-- 发送者信息 -->
        <div class="from-info">

        </div>

        <!-- 消息详情列表 -->
        <div class="msg-info-list">
          <div v-for="(item, index) in messageData.msgInfoDetail" :key="index" class="msg-info-item">
            <!-- 文本内容 -->
            <div class="content-detail" :style="{ font: item.contentDetail.font }" v-if="item.contentDetail">
              <div class="details" @click="formatUrl(item.contentDetail.url, item.contentDetail.urlType)">
                {{ item.contentDetail.content }}
              </div>

            </div>

            <!-- 图片内容 -->
            <div class="image-detail" v-if="item.imageDetail">
              <div @click="formatUrl(item.imageDetail.url, item.imageDetail.urlType)">
                <img :src="item.imageDetail.iconUrl" alt="图片" style="max-width: 300px; max-height: 300px;margin:  0 auto;" />
              </div>

            </div>
          </div>
        </div>

        <!-- 操作按钮 -->
        <!-- <div class="handle-buttons" v-if="messageData.handleButton">
          <el-button v-for="(btn, idx) in messageData.handleButton" :key="idx" :style="{ backgroundColor: btn.contentBackColour, color: btn.contentColour }" @click="formatUrl(btn.url, btn.urlType)" size="small" type="primary">
            {{ btn.content }}
          </el-button>
        </div> -->
      </div>
      <!-- <div slot="footer" class="dialog-footer">
          <el-button class="clostConfirm" @click="closeUserPersonBox()">关 闭</el-button>
        </div> -->
    </el-dialog>

  </div>
</template>
<script>
import homeHead from '../../component/homeHead.vue'
import homeSearch from '../../component/homeSearch.vue'
import homeFooter from '../../component/homeFooter.vue'
import {
  getTodoCount,
  getTodoInfo,
  getArticleListByType,

  getTodoListManage,
  getNoticeList,
} from '../../../../api/api.p'
import { dateFormat } from '../../../../libs/util'
import { fetchTodoList, } from './todoList'
import { analyseTime } from '../../../../components/filter'
// import { vMiniWeather, vMiniWeatherIcon } from 'vue-mini-weather';
import dai from './../../../../assets/homeNew/wddb-icon.png'
import daibai from '../../../../assets/todo/todo2.png'
import yi from './../../../../assets/homeNew/wdyb-icon.png'
import yibai from '../../../../assets/todo/todo3.png'
import zhui from './../../../../assets/homeNew/wfqd-icon.png'
import zhuibai from '../../../../assets/todo/todo5.png'
import ban from './../../../../assets/homeNew/xx-icon.png'
import banbai from '../../../../assets/todo/todo7.png'
import wen from './../../../../assets/homeNew/cjwt-icon.png'
import wenbai from '../../../../assets/todo/todo9.png'

import Paging from '../../page-comn/Paging.vue';
import axios from 'axios';

export default {
  props: {},
  data () {
    return {
      messageData: {
        from: {},
        msgInfoDetail: [],
        handleButton: [],
        botoom: {},
        msgStatus: {}
      },
      inputTitle: '',

      dialogUserPersonVisible: false,

      activeName: '',

      notice: 'home',
      pageNum: 1,
      pageSize: 10,
      total: 1,
      zongtiaoshu: 0,
      current: 0,
      authType: '',
      from: '',
      params: {
        // userId: '',
        // authType: '',
        // title: '',
        // flowName: '',
        // nodeName: '',
        // status: '',
        // dataType: '',
        pageNumber: 1,
        numPerPage: 3
      },
      matterIndex: 0,
      matterList: [
        {
          name: '我的待办',
          authType: 'A',
          number: 0,
          from: 'flowTodo',
          lan: dai,
          bai: daibai
        },
        {
          name: '我的已办',
          authType: 'D',
          number: 0,
          from: 'flowDone',
          lan: yi,
          bai: yibai
        },
        {
          name: '我发起的',
          authType: 'C',
          number: 0,
          from: 'flowProgress',
          lan: zhui,
          bai: zhuibai
        },
        // {
        //   name: '办结事项',
        //   authType: 'E',
        //   number: 0,
        //   from: 'flowFinish',
        //   lan: ban,
        //   bai: banbai
        // },
        {
          name: '常见问题',
          authType: 'G',
          number: 0,
          from: 'agrment',
          lan: wen,
          bai: wenbai
        },
        {
          name: '消息',
          authType: 'M',
          number: 0,
          from: 'IM',
          lan: ban,
          bai: wenbai
        },
      ],
      dataList: [],
      matterTitle: '',
      noticeList: [],

      // 仅在“我的待办(A)”场景下，监听 localStorage.hzUniqueId
      hzUniqueIdPollTimer: null
    }
  },
  filters: {

  },
  components: {
    homeHead,
    homeFooter,
    homeSearch,
    Paging
  },
  created () {
    // storage 事件：用于监听来自“其他页面/窗口”的 localStorage 更新
    this._hzUniqueIdStorageListener = (event) => {
      try {
        if (!event || event.key !== 'hzUniqueId') return
        if (event.newValue == null) return
        if (this.authType !== 'A') return
        this.handleClick(this.activeName)
      } catch (e) {
        // 忽略监听异常，避免影响页面渲染
      }
    }
  },
  mounted () {
    this.getTodoCount()
    let currentMatter = '';
    // console.log(currentMatter);
    let indexs = 0;
    // console.log(this.$route.query.indexs)
    if (this.$route.query.indexs) {
      indexs = this.$route.query.indexs;
      currentMatter = this.matterList[indexs];
      this.matterBtn(currentMatter, indexs);
    } else {
      this.matterBtn(this.matterList[0], 0);
    }

    // 初始化 storage 监听
    window.addEventListener('storage', this._hzUniqueIdStorageListener)

  },
  beforeDestroy () {
    // 清理监听与轮询
    try {
      window.removeEventListener('storage', this._hzUniqueIdStorageListener)
    } catch (e) { }
    this.stopHzUniqueIdWatch()
  },
  methods: {
    search () {
      this.dataList = []
      this.pageNum = 1;
      this.getTodoListManageFun()
      console.log(this.inputTitle)

    },
    // 根据urlType格式化跳转链接
    formatUrl (url, urlType) {

      if (urlType == '1') {
        this.$toast('此消息无法在融合门户处理，请前往「闽大通 APP」查看并处理。')
      } else if (urlType == '2') {
        this.$toast('此消息无法在融合门户处理，请前往「闽大通 APP」查看并处理。')
      } else if (urlType == '3') {
        window.open(url, '_blank');
      }

    },

    // 按钮点击事件
    handleButtonClick (btn) {
      const url = this.formatUrl(btn.url, btn.urlType);
      // 这里可以根据需求做跳转或其他操作
      window.open(url, '_blank');
    },

    // 时间戳格式化
    formatDate (timestamp) {
      if (!timestamp) return '';
      let date = new Date(timestamp);
      return date.toLocaleString();
    },
    goImIten (item) {
      let datas = JSON.parse(item.msgContent)
      console.log(datas.msgInfoDetail, '-', item, typeof datas)
      this.messageData = {
        from: {
          title: item.title,
          sendTime: item.sendTime,
        },
        msgInfoDetail: datas.msgInfoDetail,
        handleButton: datas.handleButton,
        botoom: datas.botoom,
        msgStatus: datas.msgStatus
      }

      this.dialogUserPersonVisible = true

    },
    handleClick (index) {
      const targetIndex = index || this.activeName
      this.activeName = targetIndex;

      // 如果当前在“我的待办(A)”并且存在 hzUniqueId，则触发刷新并删除该字段
      const hzUniqueId = window.localStorage.getItem('hzUniqueId')
      if (hzUniqueId) {
        window.localStorage.removeItem('hzUniqueId')
      }

      this.inputTitle = ''
      // console.log(tab)
      // console.log(tab, event);
      this.dataList = []
      this.noticeList = [];
      this.getTodoListManageFun()

    },

    scrollToTop () {
      window.scrollTo({
        top: 0,        // 滚动到页面顶部
        left: 0,       // 可以设置横向位置，如果不需要可以忽略
        behavior: 'smooth' // 平滑滚动
      });
    },
    handleCurrentChange (val, index) {
      this.pageNum = val;
      this.pageSize = index;
      if (this.authType != 'G') {
        this.getTodoListManageFun();
      } else {
        this.getArticleListByTypeFun()
      }

    },

    searchBtn (data) {
      this.$router.push({
        path: '/searchList',
        query: {
          title: data
        }
      })
    },
    goNotice (item) {
      let ids = JSON.parse(JSON.stringify(item))
      this.$router.push({
        path: '/noticeDetail',
        query: {
          articleId: ids.id,
        }
      })
    },
    //消息 
    async getNoticeListFun (item) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let param = {
        keyword: '',
        pageNumber: this.pageNum,
        numPerPage: this.pageSize
      }
      const res = await getNoticeList(param);
      if (res) {
        loading.close();
        if (res.meta.code == 0) {
          console.log(res, '--')
          this.noticeList = res.data.records;
          this.zongtiaoshu = JSON.parse(res.data.total);
        } else {
          this.$toast(res.meta.message);
        }

      } else {
        loading.close();
        this.$toast('操作失败');
      }

    },

    // 通知公告 
    async getArticleListByTypeFun (item) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let param = {
        type: '常见问题',
        title: '',
        pageNumber: this.pageNum,
        numPerPage: this.pageSize
      }
      const res = await getArticleListByType(param);
      if (res) {
        loading.close();
        if (res.meta.code == 0) {
          this.noticeList = res.data.records;
          this.zongtiaoshu = JSON.parse(res.data.total);
        } else {
          this.$toast(res.meta.message);
        }

      } else {
        loading.close();
        this.$toast('操作失败');
      }

    },

    matterBtn (item, index) {
      console.log(item, index, 'index')
      this.pageNum = 1;
      this.pageSize = 10;
      this.zongtiaoshu = 0;
      this.matterIndex = index;
      this.authType = item.authType;
      this.matterTitle = item.name;

      if (item.authType == 'G') {
        this.stopHzUniqueIdWatch()
        this.dataList = [];
        this.noticeList = [];
        this.getArticleListByTypeFun();
      } else if (item.authType == 'M') {
        this.stopHzUniqueIdWatch()
        this.dataList = [];
        this.noticeList = [];
        this.getNoticeListFun();
      } else {
        console.log(55555)

        if (item.authType == 'A') {
          this.activeName = '1'
          this.startHzUniqueIdWatch()
        } else if (item.authType == 'D') {
          this.activeName = '4'
          this.stopHzUniqueIdWatch()
        } else if (item.authType == 'C') {
          this.activeName = '6'
          this.stopHzUniqueIdWatch()
        }
        this.handleClick(this.activeName)

      }

    },

    startHzUniqueIdWatch () {
      if (this.hzUniqueIdPollTimer) return

      // 轮询兜底：确保同标签页内写入 localStorage 也能触发
      this.hzUniqueIdPollTimer = window.setInterval(() => {
        try {
          if (this.authType !== 'A') return
          if (window.localStorage.getItem('hzUniqueId')) {
            this.handleClick(this.activeName)
          }
        } catch (e) { }
      }, 1000)
    },

    stopHzUniqueIdWatch () {
      if (this.hzUniqueIdPollTimer) {
        window.clearInterval(this.hzUniqueIdPollTimer)
        this.hzUniqueIdPollTimer = null
      }
    },
    goDetail (item) {
      console.log(item)
      // this.getTodoInfo(item)
      let url = item.url
      window.open(url)
    },
    async getTodoInfo (item) {

      let param = {
        id: item.id
      }
      const res = await getTodoInfo(param);
      if (res) {

        if (res.meta.code == 0) {

          let url = res.data.appUrl + '&from=' + this.from

          window.open(url)
          // window.location.href = url;
        } else {
          this.$toast(res.meta.message);
        }

      } else if (res.meta.code == 888) {
        sessionStorage.clear()
        window.location.href = res.data;

      } else {

        this.$toast('操作失败');
      }

    },

    // 
    async getTodoListManageFun () {

      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      let param = this.params;
      param.keyword = this.inputTitle;
      param.pageNumber = this.pageNum;
      param.numPerPage = this.pageSize

      let res = await getTodoListManage(param, this.activeName);
      loading.close();

      if (res != undefined) {
        if (res.meta.code == 0) {
          let data = res.data.records
          console.log(data)
          this.dataList = data;
          // if (data.length > 0) {

          //   data.forEach(ele => {
          //     let testArr = []
          //     for (let key in ele.keyList) {
          //       testArr.push({
          //         'name': ele.keyList[key],
          //         'value': ele.valueList[key]
          //       })
          //     }
          //     ele.testArr = testArr
          //   })

          // }


          // this.zongtiaoshu = res.data.total;
        }

      }


    },



    /*获取事项列表*/
    async fetchTodoListFun () {

      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      let param = this.params;
      param.authType = this.authType;
      param.pageNumber = this.pageNum;
      param.numPerPage = this.pageSize

      let res = await fetchTodoList(param);
      loading.close();

      if (res != undefined) {
        if (res.meta.code == 0) {
          let data = res.data.records

          if (data.length > 0) {

            data.forEach(ele => {
              let testArr = []
              for (let key in ele.keyList) {
                testArr.push({
                  'name': ele.keyList[key],
                  'value': ele.valueList[key]
                })
              }
              ele.testArr = testArr
            })

          }

          this.dataList = data;
          this.zongtiaoshu = res.data.total;
        }

      }


    },

    // 事项 数量
    async getTodoCount () {

      let params = {
        dataType: '',
        userId: '',
      }
      const res = await getTodoCount(params)
      if (res) {
        if (res.meta.code == 0) {
          let data = res.data;
          this.matterList[0].number = data.todoNum
          this.matterList[1].number = data.doneNum
          this.matterList[2].number = data.createNum//todo 进度追踪
          this.matterList[3].number = data.endNum//办结事项


        } else {
          this.$toast(res.meta.message);
        }
      } else {
        this.$toast('操作失败');
      }
    },



  },
}
</script>

<style lang="less" scoped>
@import './myTask.less';
.search-header__quick__search {
  width: 274px;
  height: 36px;
  background: #ffffff;
  border-radius: 18px;
  position: relative;
  margin-right: 8px;
  margin-top: 10px;

  input {
    border: 0;
    width: 100%;
    height: 36px;
    border-radius: 18px;
    padding-left: 10px;
    &::placeholder {
      font-family: SourceHanSansCN, SourceHanSansCN;
      font-weight: 400;
      font-size: 14px;
      color: #1e4fa1;
      padding-left: 24px;
    }
  }
  .home-header__quick__search__icon {
    width: 16px;
    height: 16px;
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>
